import {
  Button,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@clearcover/atlas';
import { draftEndpointModifier } from 'Policies/utils';
import { usePolicyContext } from 'Policies/utils/PolicyContext/PolicyContext';
import React, { FC, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { FormInput } from 'Shared/components';
import { useLazyApi } from 'Shared/services/Api';
import { mldDiscountType } from '../PolicyDiscountSection';
import styles from './styles.module.css';

export const multiLineDiscountsOptions = {
  none: '',
  homeowner: 'Homeowner',
  renter: 'Renter',
  condominiumOwner: 'Condominium Owner',
};
export const EditDiscountForm: FC<{
  closeModal: () => void;
  mldDiscount: mldDiscountType | undefined;
}> = ({ closeModal, mldDiscount }) => {
  const history = useHistory();

  const { id: policyId, draftId } = useParams<{
    id: string;
    draftId: string;
  }>();
  const {
    refetchHandler,
    details: { draftType },
    flags: { renewalQuotesEnabled },
  } = usePolicyContext();

  const [{ loading, error }, updateMultiLineDiscount] = useLazyApi<{
    draftId: string;
  }>({
    method: 'POST',
    url: `/policies/${policyId}/updateMultiLine${draftEndpointModifier(
      draftType,
      renewalQuotesEnabled
    )}`,
  });
  const [hasDiscount, updateHasDiscount] = useState(
    mldDiscount?.type !== 'none'
  );

  const [multiLineDiscountType, updateDiscountType] = useState<string>(
    mldDiscount?.type ?? 'none'
  );
  return (
    <div data-testid={'edit-mld-discount-form'} className={styles.container}>
      <ModalHeader className={styles.header}>
        {' '}
        <h5>Edit Discount</h5>
      </ModalHeader>
      <ModalContent className={styles.content}>
        <h1>Multi-line Discount</h1>
        <div className={styles.form}>
          <FormInput
            variant="radioButtonGroup"
            name="insure-other-lines"
            data-testid="insure-other-lines-select"
            options={{ yes: 'yes', no: 'no' }}
            value={hasDiscount ? 'yes' : 'no'}
            onChange={(value: string) => {
              if (value === 'no') {
                updateDiscountType('none');
                updateHasDiscount(false);
              } else {
                updateHasDiscount(true);
              }
            }}
            label="Does the customer insure other lines with agency?"
          />
          <FormInput
            label={'What other lines are insured for this customer?'}
            data-testid={'other-line-options'}
            onChange={(value: string) => {
              updateDiscountType(value);
              if (value === 'none') {
                updateHasDiscount(false);
              } else {
                updateHasDiscount(true);
              }
            }}
            value={multiLineDiscountType}
            variant="select"
            options={multiLineDiscountsOptions}
          />
          <div className={styles.error}>{error?.message} </div>
        </div>
      </ModalContent>
      <ModalFooter>
        <div className={styles.buttonGroup}>
          <Button
            variant="danger-secondary"
            isSubmitting={false}
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            isSubmitting={loading}
            disabled={multiLineDiscountType === 'none' && hasDiscount}
            onClick={() => {
              updateMultiLineDiscount({
                data: {
                  multiLineDiscountType,
                },
              }).then(({ data }) => {
                draftId === data.draftId
                  ? refetchHandler()
                  : history.push(`/policies/${policyId}/draft/${data.draftId}`);
              });
            }}
          >
            Save & Continue
          </Button>
        </div>
      </ModalFooter>
    </div>
  );
};
